import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { TextField, FormControlLabel, Checkbox, Typography } from '@material-ui/core';
import { RadioButtonUnchecked, RadioButtonChecked } from '@material-ui/icons';

import style from './commonTruckerLocked.module.css';
import commonStyles from '../../../common/common.module.css';

import Grid from '@material-ui/core/Grid';

const GHA_EXPORT_VIEW = 'ghaExport';
const WHS_MOBILE_VIEW = 'whsMobile';
const TEXT_FIELD_PADDINGS: string = '6px 12px';
const TEXT_FIELD_PADDINGS_GHA_EXPORT: string = '6px 12px';
const TEXT_FIELD_PADDINGS_WHS_MOBILE: string = '6px 12px';

const styles = (theme: Theme) =>

  createStyles({
    blue: {
      color: 'var(--primaryblue)',
    },
    grey: {
      color: 'rgb(0,0,0,0.26)',
    },
    greyDriver: {
      transform: 'translate(14px, 14px) scale(1)',
      color: 'grey'
    },
    label: {
      color: 'grey',
      fontSize: '14px',
      marginRight: '10px'
    },
    fieldWidth: {
      width: '100%',
    },
    driverLabel: {
      color: 'var(--primaryblue)',
      fontSize: '0.8125rem'
    },
    driverFieldWidth: {
      width: '98%',
      marginLeft: '2%',
      '&: error': {
        color: 'green'
      },
      '& fieldset': {
        borderRadius: '20px',
        '&: error': {
          borderColor: 'green'
        },
      },
    },
    griditem: {
      maxWidth: '100%',
    },
    wrapperDesktop:{
      flexWrap:'wrap'
    }
  });

interface CommonTruckerLockedProps {
  classes: any;
  view: string;
  sealed: boolean;
  locked: boolean;
  sealNumber: string;
  sealNumberMandatory?: boolean;
  handleChange: (event: any) => void;
  handleSetSealNumber: (event: any) => void;
  handleChangeSealNumber: (event: any) => void;
  disabled: boolean;
};

const commonTruckerLocked = (props: CommonTruckerLockedProps) => {

  const { classes, view } = props;
  const classNameWrapper: string = view === 'mobile' ? style.wrapperMobile : view === 'driverTextField' ? style.driverTextFieldWrapper : style.wrapperDesktop;
  const insideWrapper: string = view === 'mobile' ? style.flex : style.insideWrapperDesktop;
  const sealNumberWidth: string = view === GHA_EXPORT_VIEW ? '100%' : '100%';
  let sealNumberPadding: string = TEXT_FIELD_PADDINGS;
  const fontSizeIcon: string = view === 'mobile' ? '30px' : view === 'driverTextField' ? '24px' : '26px';
  const textFieldWrapper: string = view === 'mobile' ? style.textFiledWrapper : style.textFiledWrapperDesktop;

  if (view === GHA_EXPORT_VIEW) {
    sealNumberPadding = TEXT_FIELD_PADDINGS_GHA_EXPORT;
  }

  if (view === WHS_MOBILE_VIEW) {
    sealNumberPadding = TEXT_FIELD_PADDINGS_WHS_MOBILE;
  }

  return (
    <div className={classNameWrapper}>
      <Grid container direction="row" className={style.sealContainerMain}>
        <Grid item xs={7} className={style.sealContainer}>
          <div className={insideWrapper}>
            <Grid container direction="row" className={style.gridContainer} >
              <Grid item xs={6} className={classes.griditem} >
                <FormControlLabel
                  value="locked"
                  control={
                    <Checkbox
                      name='locked'
                      checked={props.locked}
                      onChange={props.handleChange}
                      icon={<RadioButtonUnchecked style={{ fontSize: fontSizeIcon }} color={view === 'driverTextField' ? "primary" : 'inherit'} />}
                      checkedIcon={<RadioButtonChecked style={{ fontSize: fontSizeIcon }} color="primary" />}
                      classes={{
                        root: style.checkbox,
                      }}
                    />
                  }
                  label={<Typography className={view === 'mobile' ? classes.label : view === 'driverTextField' ? classes.driverLabel : ''}>Locked</Typography>}
                  disabled={props.disabled}
                />
              </Grid>
              <Grid item xs={6} className={classes.griditem}>
                <FormControlLabel
                  value="sealed"
                  control={
                    <Checkbox
                      name='sealed'
                      onChange={props.handleChange}
                      checked={props.sealed}
                      icon={<RadioButtonUnchecked style={{ fontSize: fontSizeIcon }} color={view === 'driverTextField' ? "primary" : 'inherit'} />}
                      checkedIcon={<RadioButtonChecked style={{ fontSize: fontSizeIcon }} color="primary" />}
                      classes={{
                        root: style.checkbox,
                      }}
                    />
                  }
                  label={<Typography className={view === 'mobile' ? classes.label : view === 'driverTextField' ? classes.driverLabel : ''}>Sealed</Typography>}
                  disabled={props.disabled}
                />
              </Grid>
            </Grid>

          </div>
        </Grid>
        <Grid item xs={5} className={[classes.griditem, style.sealField].join(" ")}>
          <div className={ `${ textFieldWrapper } ${ commonStyles.inputLabelWrapper } ${ commonStyles.mt0 }` } >
            <label className={ commonStyles.inputLabel }>Seal Number</label> 
            <TextField
              error={props.sealNumberMandatory && !props.sealNumber ? true : undefined}
              id="sealNumber"
              value={props.sealNumber}
              className={view === 'mobile' ? '' : view === 'driverTextField' ? classes.driverFieldWidth : classes.fieldWidth}
              variant="outlined"
              fullWidth={true}
              disabled={ props.disabled || !props.sealed }
              onChange={props.handleChangeSealNumber}
              onBlur={props.handleSetSealNumber}
              inputProps={{
                style: { padding: sealNumberPadding, width: sealNumberWidth }
              }}
              helperText={view !== GHA_EXPORT_VIEW
                ? (props.sealNumberMandatory && !props.sealNumber) ? 'Add seal Number' : ''
                : ''
              }
              InputLabelProps={{
                className: view === 'driverTextField' ? classes.greyDriver : view !== GHA_EXPORT_VIEW ? classes.grey : (props.sealNumber ? classes.blue : classes.grey)
              }}
            />
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default withStyles(styles)(commonTruckerLocked);